import React, { useMemo } from 'react';
import Navigation from '../navigation';
import CollaborateBlock from './collaborationBlock';
import NewsSubscription from './subscriptionBlock';
import { useLocation, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../logo';

export default React.memo(function Footer() {
  const location = useLocation();
  const params = useParams();
  const { t } = useTranslation('common');

  const ContactsBlock = useMemo(() => {
    let block = CollaborateBlock;
    if (/\/news\//.test(location.pathname) && params.hasOwnProperty('id')) block = NewsSubscription;
    return block;
  }, [location.pathname]);

  const year = new Date().getFullYear();

  return (
    <section className={'flex items-center flex-col bg-black gap-20 w-full'}>
      {/*<ContactsBlock />*/}

      <div className={'w-full flex items-center p-10 gap-10 text-white'}>
        <div className={'w-full flex flex-col items-center justify-center gap-8'}>
          <Logo className={'flex justify-start'} logoClassName={'w-30 h-7 fill-white  items-center'} />
          <div
            className={'w-full flex flex-col md:flex-row justify-start max-w-6xl gap-8 text-center text-white opacity-50  text-sm font-normal'}>
            <span>&copy; {year} EPICPLAY. {t('labels.rights_reserved')}</span>
          </div>
        </div>
        <div className={'w-full flex md:flex-col [&>*]:flex-1 font-normal gap-8'}>
          <div>
            <Navigation
              className={'[&_a]:!text-white opacity-50 [&>ul]:flex-col [&>ul]:flex-end [&>ul]:items-end [&>ul]:gap-3 [&>ul]:gap-x-28 md:[&>ul]:flex-row md:[&>ul]:gap-8 text-sm font-normal'} />
          </div>
          <div className={'w-full h-max flex justify-end'}>
            <ul
              className={'grid grid-cols-1 md:grid-cols-[repeat(3,_minmax(0,_max-content))] items-center gap-3 md:gap-6 w-full md:w-max text-white opacity-50 text-sm font-normal'}>
              <li className={'order-1 md:order-1'}>
                <Link to={'/terms'}>
                  {t('navigation.terms')}
                </Link>
              </li>
              <li className={'order-2 md:order-2'}>
                <Link to={'/privacy-policy'}>
                  {t('navigation.privacy_policy')}
                </Link>
              </li>
              <li className={'order-3 md:order-2'}>
                <Link to={'/privacy-policy'}>
                  {t('navigation.gaming18')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
})
